import { GetTokenSilentlyOptions, LogoutOptions, User } from "@auth0/auth0-react";

let getAccessTokenSilently: (options?: GetTokenSilentlyOptions | undefined) => Promise<string>;
let getUser: (() => User | undefined) | null = null;

export interface OrganizationMetadata {
  api_base_url?: string;
  [key: string]: any;
}

export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (
    func: (options?: GetTokenSilentlyOptions | undefined) => Promise<string>
  ) => (getAccessTokenSilently = func),

  getUser: () => getUser,
  setGetUser: (func: () => User | undefined) => (getUser = func),

  /**
   * Extract API base URL from custom claims in the ID token
   * This should be set via an Auth0 Action that adds organization metadata to the token
   */
  getApiBaseUrlFromToken(): string | null {
    try {
      const user = getUser?.();
      if (!user) {
        return null;
      }

      // Check for API base URL in the specific custom claim
      const apiBaseUrl = user["https://jylo.ai/api_base_url"];

      if (!apiBaseUrl) {
        return null;
      }

      return apiBaseUrl;
    } catch (error) {
      console.error("Error extracting API base URL from token:", error);
      return null;
    }
  },
};
